export const filmFacts = [
  { label: "片名", value: "色，戒 / Lust, Caution" },
  { label: "原著", value: "张爱玲同名短篇《色，戒》（1978 年收录于《惘然记》）" },
  { label: "导演", value: "李安" },
  { label: "主演", value: "梁朝伟、汤唯、王力宏、陈冲" },
  { label: "上映年份", value: "2007 年" },
  { label: "主要荣誉", value: "第 64 届威尼斯电影节金狮奖" },
  { label: "配乐", value: "亚历山大·帕雷斯普拉（Alexandre Desplat）" },
  { label: "片长参考", value: "未删减版约 158 分钟；内地公映版约 145 分钟" },
];

export const navItems = [
  { id: "overview", label: "版本概览" },
  { id: "compare", label: "删减对比" },
  { id: "cuts", label: "删减片段" },
  { id: "plot", label: "完整剧情" },
  { id: "characters", label: "人物解析" },
  { id: "intimate", label: "情欲戏解读" },
  { id: "ending", label: "结局解析" },
  { id: "behind", label: "幕后之争" },
  { id: "faq", label: "常见问题" },
];

export const statsBand = [
  { value: "约 158", unit: "分钟", label: "未删减版片长参考" },
  { value: "约 7", unit: "分钟", label: "内地公映版主要删减时长参考" },
  { value: "NC-17", unit: "级", label: "未删减版在美国的分级" },
  { value: "3", unit: "场", label: "贯穿全片的亲密戏，删减核心" },
];

export const versionColumns = [
  {
    key: "uncut",
    title: "未删减版",
    subtitle: "完整版本",
    accent: "primary",
    rows: [
      "完整保留三场亲密戏，人物关系转折清晰可见",
      "片长更长，叙事节奏与情绪铺陈更完整",
      "在美国以 NC-17 级上映，未做画面修剪",
      "部分暴力与裸露镜头完整呈现",
      "易先生与王佳芝的权力消长有完整呈现",
    ],
  },
  {
    key: "cut",
    title: "内地公映版",
    subtitle: "修剪版本",
    accent: "secondary",
    rows: [
      "删去三场亲密戏，仅以含蓄镜头衔接",
      "片长缩短，人物情感转折显得更突兀",
      "对裸露与部分暴力画面做了处理",
      "主线剧情、人物与结局保持一致",
      "适合对画面尺度敏感的观众观看",
    ],
  },
];

export const diffCards = [
  {
    icon: "ri-film-line",
    title: "情欲戏的完整度",
    desc: "最受关注的差异集中在三场亲密戏。未删减版将这三场戏作为完整的叙事段落呈现，而公映版以简化处理带过，观众较难从中读到两人关系的演变过程。",
  },
  {
    icon: "ri-time-line",
    title: "片长与节奏",
    desc: "删减使成片时长缩短，但也改变了叙事的呼吸感。未删减版保留了更多铺陈与停顿，人物的心理变化有更充足的过渡空间。",
  },
  {
    icon: "ri-shield-star-line",
    title: "分级与尺度",
    desc: "未删减版在多个地区被评为限制级，美国定级为 NC-17，属于当时主流商业片中较为罕见的高分级。公映版则对裸露与部分暴力镜头做了处理。",
  },
  {
    icon: "ri-links-line",
    title: "剧情连贯性",
    desc: "删减并不改变故事走向与结局，但会削弱某些因果链条。有观众反映，删减后较难理解王佳芝心态转变的递进，需要靠情节补全。",
  },
];

export const cutScenes = [
  {
    tag: "亲密戏",
    title: "第一场：暴力与征服",
    summary:
      "易先生与王佳芝的第一次身体接触被处理得近乎粗暴。这场戏的功能并非情欲本身，而是确立两人之间「支配与被支配」的初始关系。",
    lost: "删减后，这段关系建立的心理基础被弱化，观众较难感受到王佳芝最初的身份被动与警觉。",
  },
  {
    tag: "亲密戏",
    title: "第二场：拉扯与试探",
    summary:
      "第二场戏里两人姿态与主动权的微妙变化，被普遍解读为关系开始转向。谁掌控节奏，谁开始动摇，是这场戏留给观众的关键信息。",
    lost: "删减后，两人关系从「交易」走向「纠缠」的中间环节缺失，转折显得跳脱。",
  },
  {
    tag: "亲密戏",
    title: "第三场：权力反转",
    summary:
      "第三场戏被许多影评人视为全片的情感核心。镜头里主动权发生转移，配合后续的钻戒情节，构成王佳芝最终抉择的铺垫。",
    lost: "缺少这场戏，结尾处王佳芝的动摇与心软会显得缺乏依据，成为删减影响剧情理解最明显的一处。",
  },
  {
    tag: "画面尺度",
    title: "裸露与身体镜头",
    summary:
      "未删减版包含若干裸露镜头，均为服务于人物关系表达的画面处理，而非独立的展示性段落。",
    lost: "公映版对相关画面做了处理，属于分级与审核层面的差异，不影响主线。",
  },
  {
    tag: "暴力镜头",
    title: "暴力与刑讯段落",
    summary:
      "影片涉及时代背景下的暴力与刑讯段落，未删减版保留得更为完整，用于建立人物所处环境的残酷性。",
    lost: "公映版对部分镜头做了弱化，紧张感略有降低，但不改变情节走向。",
  },
  {
    tag: "对白与细节",
    title: "零星对白与转场",
    summary:
      "除画面外，不同版本在个别对白与转场处理上也存在细微差别，多为配合删减后的衔接调整。",
    lost: "这类调整较为隐蔽，普通观众不易察觉，但对熟悉影片的人是可以辨认的版本痕迹。",
  },
];

export const plotTimeline = [
  {
    phase: "第一幕 · 香港",
    title: "从学生话剧到一场稚嫩的刺杀",
    desc: "1938 年，岭南大学学生王佳芝随校南迁香港。在爱国情绪与同窗邝裕民的推动下，她随一群学生以话剧社为掩护，策划接近汪伪政权的特务头子易先生。王佳芝假扮「麦太太」出入易家，与易太太周旋，刺杀计划却在易家突然搬离香港后戛然而止。",
  },
  {
    phase: "第二幕 · 上海",
    title: "再度入局，越走越深",
    desc: "三年后，上海。当年的同学被地下组织收拢，重新找到王佳芝。她再一次走进易家，也再一次把自己交还给一个未完成的计划。这一次，她不再只是扮演，而是在真实与伪装之间逐渐失去了界限。",
  },
  {
    phase: "第三幕 · 纠缠",
    title: "在亲密与试探中，立场开始松动",
    desc: "易先生与王佳芝反复周旋。监视、防备、依赖与试探缠绕在一起，两人的关系变得难以定义。刺杀任务仍在推进，但王佳芝对任务、对易先生、甚至对自己的判断，都开始动摇。",
  },
  {
    phase: "第四幕 · 抉择",
    title: "珠宝店里的一瞬",
    desc: "易先生带王佳芝去取定制的钻戒。那一刻的姿态与心意，让王佳芝在关键时刻轻声让他「走」。计划在最后一刻崩塌，易先生逃脱，王佳芝与同伴随即被捕。",
  },
  {
    phase: "尾声 · 收束",
    title: "一张空床与一个背影",
    desc: "易先生坐在王佳芝曾住过的房间，神色难辨。影片在此收束，没有给出廉价的答案，只把一个复杂的人的复杂心境留在画面里。",
  },
];

export const characters = [
  {
    name: "王佳芝",
    role: "女主角 · 学生 / 话剧演员",
    desc: "从岭南大学的学生，到化身「麦太太」的潜伏者。她既是执行者，也是被消耗的人。她的悲剧在于，戏演到最后，连自己也分不清哪一层是真心。",
  },
  {
    name: "易先生",
    role: "汪伪政权特务头子",
    desc: "身处权力漩涡，警觉、压抑、多疑。他对王佳芝的靠近掺着戒备与依赖，既危险又脆弱，是影片最难以简单评判的人物。",
  },
  {
    name: "邝裕民",
    role: "爱国青年 · 组织者",
    desc: "刺杀计划的发起者之一，曾对王佳芝抱有情感。他的理想与他亲手把同伴推入险境的现实之间，构成了尖锐的对照。",
  },
  {
    name: "易太太",
    role: "易先生之妻",
    desc: "在牌桌上周旋的贵妇人。她的从容与试探，是王佳芝进入易家的第一道关口，也是那个年代上流社交氛围的缩影。",
  },
  {
    name: "赖秀金 / 梁润生",
    role: "同窗同学",
    desc: "一同参与计划的年轻人。他们的青涩与冲动，让这场刺杀从一开始就带着少年人的天真与残酷。",
  },
  {
    name: "老吴",
    role: "地下组织联络人",
    desc: "把王佳芝重新拉回局中的一环。冷静、克制、以大局为重，也正因如此显得格外冷硬。",
  },
];

export const intimateAnalysis = [
  {
    title: "为什么这三场戏删不得",
    desc: "在影片的叙事结构里，三场亲密戏不是点缀，而是人物关系的三段刻度：从压制、到拉扯、到反转。它们承担了台词无法完成的心理交代。",
  },
  {
    title: "身体即战场",
    desc: "两人之间没有可以信任的对话，所有试探都通过距离、姿态和身体的攻守完成。亲密戏在这里更像一场无声的博弈，是权力关系的可视化。",
  },
  {
    title: "表演与真实之间",
    desc: "王佳芝一直在「演」。但正是这些无法凭表演掌控的场景，让假戏与真情彼此侵蚀。删去它们，等于删去了她「失守」的过程。",
  },
  {
    title: "关于观看的提醒",
    desc: "未删减版包含成人内容，内容面向成年观众。本文仅从叙事与人物角度解读相关片段的功能，不展开具体画面细节。请在适合的年龄与环境下观看。",
  },
];

export const endingAnalysis = [
  {
    q: "王佳芝为什么在最后放走易先生？",
    a: "影片没有给出单一起因。更合理的解读是，多年潜入、反复的纠缠与那一刻的心意共同作用，让她在关键一秒背离了任务。这不是一次清晰的理性判断，而是一个人被自己长期扮演的角色反噬的瞬间。",
  },
  {
    q: "易先生最后的眼神是什么意思？",
    a: "结尾没有旁白，也没有解释。他坐在曾属于她的房间里，神情复杂。有人解读为占有，有人解读为失去，也有人认为那是一种连他自己都无法命名的怅然。影片的克制正是它的锋利之处。",
  },
  {
    q: "电影结局和原著一样吗？",
    a: "主线悲剧走向与张爱玲原著一致：王佳芝在关键时刻放走了易先生，随后与同伴一同被处决。差异更多在于叙事视角与心理刻画的侧重，李安把大量笔墨放在了关系本身。",
  },
];

export const behindScenes = [
  {
    icon: "ri-movie-2-line",
    title: "李安对删减的态度",
    desc: "导演曾多次表达，这几场戏对于人物关系与影片表达是必要的。在他看来，删掉它们会让观众难以理解人物之间的心理变化，这也是版本差异被反复讨论的原因。",
  },
  {
    icon: "ri-quill-pen-line",
    title: "改编自张爱玲",
    desc: "原著《色，戒》是张爱玲反复修改多年的作品。电影在保留其冷静与锋利的同时，用影像补足了小说里含蓄留白的关系张力。",
  },
  {
    icon: "ri-award-line",
    title: "金狮奖与争议同行",
    desc: "影片在威尼斯拿下金狮奖，获得高度评价，同时也因分级与尺度引发广泛讨论。奖项与争议并存，反而让它成为当年被谈论最多的华语电影之一。",
  },
  {
    icon: "ri-history-line",
    title: "时代背景的分量",
    desc: "故事发生在抗战时期，人物被时代裹挟。无论是学生的热血，还是特务的压抑，都是那个年代留给个体的一道难题，也是理解人物动机的关键。",
  },
];

export const faqItems = [
  {
    q: "色戒未删减版到底多了什么？",
    a: "最主要的是完整保留了全片三场亲密戏，以及若干裸露与暴力镜头的完整呈现。这些内容在公映版中被处理或删去。",
  },
  {
    q: "公映版一共删了多少？",
    a: "常被引用的是内地公映版相较未删减版删减了约数分钟的片段，其中以亲密戏为主。不同地区发行版本的具体时长可能略有差异。",
  },
  {
    q: "只看删减版会影响理解剧情吗？",
    a: "主线剧情、人物与结局都能看懂。但缺少亲密戏的过渡，会让王佳芝的心态变化显得跳跃，这也是很多人觉得删减版「看不透人物」的原因。",
  },
  {
    q: "未删减版适合什么观众？",
    a: "包含成人内容与暴力画面，建议成年观众在合适的环境下观看。未满十八岁或对相关画面敏感的观众，可选择公映版本。",
  },
  {
    q: "影片和原著有哪些不同？",
    a: "原著篇幅短小、笔法极简，很多关系靠留白。电影则把关系与心理进行了充分展开，叙事更完整，情感铺陈也更直接。",
  },
  {
    q: "这几种版本的主线结局有区别吗？",
    a: "没有。无论哪个版本，故事走向与结局都保持一致，差异集中在亲密戏的呈现、片长以及个别画面的处理上。",
  },
];